export default __webpack_public_path__ + "static/media/14.6df28f3e.png";